var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 49,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 27V25C32 23.9391 31.5786 22.9217 30.8284 22.1716C30.0783 21.4214 29.0609 21 28 21H20C18.9391 21 17.9217 21.4214 17.1716 22.1716C16.4214 22.9217 16 23.9391 16 25V27",
    stroke: "#A9ABB6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17C26.2091 17 28 15.2091 28 13C28 10.7909 26.2091 9 24 9C21.7909 9 20 10.7909 20 13C20 15.2091 21.7909 17 24 17Z",
    stroke: "#A9ABB6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0742 33.9883V39.584H16.0703V33.9883H20.0742ZM16.8125 38.959H19.3125V34.6035H16.8125V38.959ZM21.666 41.791V33.1094H22.4277V36.5762H23.8828V37.2402H22.4277V41.791H21.666ZM31.5098 33.1094V41.8105H30.7383V33.1094H31.5098ZM24.6738 36.8105C24.6787 34.9648 25.5967 33.7881 26.8906 33.7832C28.1797 33.7881 29.1123 34.9648 29.1074 36.8105C29.1123 38.6611 28.1797 39.833 26.8906 39.8281C25.5967 39.833 24.6787 38.6611 24.6738 36.8105ZM25.416 36.8105C25.416 38.2217 26.0215 39.1494 26.8906 39.1445C27.7646 39.1494 28.3652 38.2217 28.3652 36.8105C28.3652 35.3994 27.7646 34.4717 26.8906 34.4668C26.0215 34.4717 25.416 35.3994 25.416 36.8105Z",
    fill: "#A9ABB6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyicon);
export default __webpack_public_path__ + "static/media/myicon.f6e6264ca9c14ed7890f577a1edf7bbc.svg";
export { ForwardRef as ReactComponent };